// eslint-disable-next-line
import { UserLayout, BasicLayout,OutPage,Block } from '@/layouts'

export const asyncRouter = {

}

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/mansion',
    name: 'index',
    component: BasicLayout,
    redirect:'/mansionPage',
    meta: { title: '首页',key:'DATABASE'},
    children: [
      {
        path: '/mansionPage',
        redirect: '/mansionDetail',
        component: () => import('@/layouts/PageView'),
        children: [
          {
            path: '/mansionDetail',
            name: 'mansionDetail',
            component: () => import('@/views/database/mansionDetail/Index'),
            meta: {key:'MansionData', title: 'router.database.mansionDetail', hiddenHeaderContent: true, icon: 'read' }
          }
        ]
      },
      {
        path: '/searchOverallPage',
        redirect: '/searchOverallPage',
        component: () => import('@/layouts/PageView'),
        children: [
          {
            path: '/searchOverallPage',
            name: 'searchOverallPage',
            component: () => import('@/components/searchOverall/index'),
            meta: {key:'so', title: '搜索首页' }
          }
        ]
      },
      {
        path: '/searchOverallMansion',
        redirect: '/searchOverallMansion',
        component: () => import('@/layouts/PageView'),
        children: [
          {
            path: '/searchOverallMansion',
            name: 'searchOverallMansion',
            component: () => import('@/components/searchOverall/mansionDetail'),
            meta: {key:'so', title: '大厦详情' }
          }
        ]
      },
      {
        path: '/searchOverall',
        redirect: '/searchOverall',
        component: () => import('@/layouts/PageView'),
        children: [
          {
            path: '/searchOverall',
            name: 'searchOverall',
            component: () => import('@/components/searchOverall'),
            meta: {key:'so', title: '搜索首页' }
          }
        ]
      },
      {
        path: '/addOrEditMansionPage',//新增编辑楼宇页面
        redirect: '/addOrEditMansion',
        component: () => import('@/layouts/PageView'),
        children: [
          {
            path: '/addOrEditMansion',
            name: 'addOrEditMansion',
            component: () => import(/* webpackChunkName: "user" */ '@/views/database/mansionDetail/addOrEditMansion'),
            meta: {key:'MansionData', title: 'router.database.addOrEditMansion', hiddenHeaderContent: true, icon: 'read' }
          }
        ]
      },
      {
        path: '/addOrEditIndustrial',//新增编辑产业园信息
        redirect: '/addOrEditIndustrial',
        component: () => import('@/layouts/PageView'),
        children: [
          {
            path: '/addOrEditIndustrial',
            name: 'addOrEditIndustrial',
            component: () => import(/* webpackChunkName: "user" */ '@/views/database/industrial/module/addOrEditIndustrial'),
            meta: {key:'Industrial', title: 'router.database.addOrEditIndustrial', hiddenHeaderContent: true, icon: 'read' }
          }
        ]
      },
      {
        path: '/industrialDetail',//产业园信息详情
        redirect: '/industrialDetail',
        component: () => import('@/layouts/PageView'),
        children: [
          {
            path: '/industrialDetail',
            name: 'industrialDetail',
            component: () => import(/* webpackChunkName: "user" */ '@/views/database/industrial/module/industrialDetail'),
            meta: {key:'Industrial', title: 'router.database.industrialDetail', hiddenHeaderContent: true, icon: 'read' }
          }
        ]
      },
      {
        path: '/industrialServiceList',//智库服务列表
        redirect: '/industrialServiceList',
        component: () => import('@/layouts/PageView'),
        children: [
          {
            path: '/industrialServiceList',
            name: 'industrialServiceList',
            component: () => import(/* webpackChunkName: "thinkTankService" */ '@/views/database/thinkTankService/index'),
            meta: {key:'Industrial', title: 'router.database.thinkTankService', hiddenHeaderContent: true, icon: 'read' }
          }
        ]
      },
      {
        path: '/editOption',//编辑楼宇option
        redirect: '/editOption',
        component: () => import('@/layouts/PageView'),
        children: [
          {
            path: '/editOption',
            name: 'editOption',
            component: () => import(/* webpackChunkName: "user" */ '@/views/database/mansionDetail/editOption'),
            meta: {key:'MansionData', title: 'router.database.editOption', hiddenHeaderContent: true, icon: 'read' }
          }
        ]
      },
      {
        path: '/editOptionBeijing',//编辑楼宇option
        redirect: '/editOptionBeijing',
        component: () => import('@/layouts/PageView'),
        children: [
          {
            path: '/editOptionBeijing',
            name: 'editOptionBeijing',
            component: () => import(/* webpackChunkName: "user" */ '@/views/database/mansionDetail/editOptionBeijing'),
            meta: {key:'MansionData', title: 'router.database.editOption', hiddenHeaderContent: true, icon: 'read' }
          }
        ]
      },
      {
        path: '/hgandleInduction',//手动办理入职
        redirect: '/hgandleInduction',
        component: () => import('@/layouts/PageView'),
        children: [
          {
            path: '/hgandleInduction',
            name: 'hgandleInduction',
            component: () => import(/* webpackChunkName: "user" */ '@/views/sys/induction/module/hgandleInduction'),
            meta: {key:'MansionData', title: 'router.database.hgandleInduction', hiddenHeaderContent: true, icon: 'read' }
          }
        ]
      },
      {
        path: '/mansionStatisticsPage',//地图查询页面
        redirect: '/mansionStatistics',
        component: () => import('@/layouts/PageView'),
        children: [
          {
            path: '/mansionStatistics',
            name: 'mansionStatistics',
            component: () => import(/* webpackChunkName: "user" */ '@/views/database/mansionStatistics/Index'),
            meta: {key:'MansionData', title: 'router.database.mapTitle', hiddenHeaderContent: true, icon: 'read' }
          }
        ]
      },
      {
        path: '/message',//消息页面
        redirect: '/message',
        component: () => import('@/layouts/PageView'),
        children: [
          {
            path: '/message',
            name: 'message',
            component: () => import(/* webpackChunkName: "user" */ '@/views/message/index'),
            meta: {key:'newsMessage', title: 'router.database.messageTitle', hiddenHeaderContent: true, icon: 'read' }
          }
        ]
      },
      {
        path: '/collection',//我的收藏頁面
        redirect: '/collection',
        component: () => import('@/layouts/PageView'),
        children: [
          {
            path: '/collection',
            name: 'collection',
            component: () => import(/* webpackChunkName: "user" */ '@/views/mine/collection/index'),
            meta: {key:'newsCollection', title: 'router.database.collectionTitle', hiddenHeaderContent: true, icon: 'read' }
          }
        ]
      },
    ]
  },
  {
    path: '/expense',
    name: 'index',
    component: BasicLayout,
    redirect:'/expense',
    meta: { title: '首页',key:'MINI' },
    children: [
      {
        path: '/expensePage',
        redirect: '/expenseDetail',
        component: () => import('@/layouts/PageView'),
        meta:{key:'Expense'},
        children: [
          {
            path: '/mine/expense/add',
            name: 'expenseAdd',
            component: () => import('@/views/mine/expense/apply/module/form'),
            meta: {key:'ExpenseApply',title: 'router.mine.expense.addExpense', hiddenHeaderContent: true, icon: 'read' }
          }
        ]
      },
    ]
  },
  {
    path: '/payment',
    name: 'index',
    component: BasicLayout,
    redirect:'/payment/add',
    meta: { title: '首页',key:'MINI' },
    children: [
      {
        path: '/payment/add',
        redirect: '/mine/payment/add',
        component: () => import('@/layouts/PageView'),
        meta:{key:'payment'},
        children: [
          {
            path: '/mine/payment/add',
            name: 'paymentAdd',
            component: () => import('@/views/database/payment/module/addPaymentPage.vue'),
            meta: {key:'payment',title: '新增付款', hiddenHeaderContent: true, icon: 'read' }
          }
        ]
      },
    ]
  },
  {
    path: '/aps',
    name: 'sys.aps',
    component: BasicLayout,
    redirect:'/aps',
    meta: { title: '首页',key:'MINI' },
    children: [
      {
        path: '/add',
        component: () => import('@/layouts/PageView'),
        meta:{key:'aps'},
        children: [
          {
            path: '/aps/add',
            name: 'apsAdd',
            component: () => import('@/views/sys/aps/module/add'),
            meta: {key:'aps',title: 'router.systemSetting.aps', hiddenHeaderContent: true, icon: 'read' }
          },
          {
            path: '/aps/write',
            name: 'apsWrite',
            component: () => import('@/views/mine/aps/module/input'),
            meta: {key:'aps',title: 'router.systemSetting.aps', hiddenHeaderContent: true, icon: 'read' }
          },
          {
            path: '/aps/businessWrite',
            name: 'businessApsWrite',
            component: () => import('@/views/mine/aps/module/businessInput'),
            meta: {key:'aps',title: 'router.systemSetting.aps', hiddenHeaderContent: true, icon: 'read' }
          },
          {
            path: '/aps/businessScored',
            name: 'businessApsScored',
            component: () => import('@/views/mine/aps/module/businessScored'),
            meta: {key:'aps',title: 'router.systemSetting.aps', hiddenHeaderContent: true, icon: 'read' }
          },
          {
            path: '/aps/businessDetail',
            name: 'businessApsDetail',
            component: () => import('@/views/mine/aps/module/businessDetail'),
            meta: {key:'aps',title: 'router.systemSetting.aps', hiddenHeaderContent: true, icon: 'read' }
          },
          {
            path: '/aps/showDetail',
            name: 'showDetail',
            component: () => import('@/views/mine/aps/module/showDetail'),
            meta: {key:'aps',title: 'router.systemSetting.aps', hiddenHeaderContent: true, icon: 'read' }
          },{
            path: '/aps/ewrite',
            name: 'apseWrite',
            component: () => import('@/views/mine/aps/module/einput'),
            meta: {key:'aps',title: 'router.systemSetting.aps', hiddenHeaderContent: true, icon: 'read' }
          },
         {
            path: '/aps/hkWrite',
            name: 'apsHkWrite',
            component: () => import('@/views/mine/aps/module/hk-input'),
            meta: {key:'ReviewHK',title: 'router.mine.ReviewHK', hiddenHeaderContent: true, icon: 'read' }
          },
          {
            path: '/aps/hkScored',
            name: 'apsHKeWrite',
            component: () => import('@/views/mine/aps/module/hk-scored'),
            meta: {key:'ScoredHK',title: 'router.mine.ScoredHK', hiddenHeaderContent: true, icon: 'read' }
          },
          {
            path: '/aps/hkDetail',
            name: 'apsHKeWrite',
            component: () => import('@/views/mine/aps/module/hk-detail'),
            meta: {key:'ReviewHK',title: 'router.mine.ReviewHK', hiddenHeaderContent: true, icon: 'read' }
          },
          {
            path: '/aps/eshowDetail',
            name: 'showeDetail',
            component: () => import('@/views/mine/aps/module/eshowDetail'),
            meta: {key:'aps',title: 'router.systemSetting.aps', hiddenHeaderContent: true, icon: 'read' }
          },
          {
            path: '/aps/apsInfoShowDetail',
            name: 'apsInfoShowDetail',
            component: () => import('@/views/manager/aps/module/eshowDetail'),
            meta: {key:'apsInfo',title: 'router.systemSetting.apsInfo', hiddenHeaderContent: true, icon: 'read' }
          }
        ]
      },
    ]
  },
  {
    path: '/leaveSetting',
    name: 'index',
    component: BasicLayout,
    redirect:'/leaveSettingPage',
    meta: { title: '首页',key:'Manager' },
    children: [
      {
        path: '/leaveSettingPage',
        redirect: '/manager/leaveSetting/edit',
        component: () => import('@/layouts/PageView'),
        meta:{key:'personSetting'},
        children: [
          {
            path: '/manager/leaveSetting/editStaff',
            name: 'staffHoliday',
            component: () => import('@/views/manager/leaveSetting/module/staffHoliday'),
            meta: {key:'LeaveSetting', title: 'router.manager.leaveSettingEdit', hiddenHeaderContent: true, icon: 'read' }
          },
          {
            path: '/manager/leaveSetting/editpublic',
            name: 'publicHoliday',
            component: () => import('@/views/manager/leaveSetting/module/publicHoliday'),
            meta: {key:'LeaveSetting',  title: 'router.manager.leaveSettingEditPub', hiddenHeaderContent: true, icon: 'read' }
          },
          {
            path: '/manager/wages/addWages',
            name: 'addWages',
            component: () => import('@/views/manager/wagesDetailed/module/addWages'),
            meta: {key:'WagesDetailed', title: 'router.manager.addWages', hiddenHeaderContent: true, icon: 'read' }
          }
        ]
      },
    ]
  },
  {
    path: '/approve',
    name: 'index',
    component: BasicLayout,
    redirect:'/approvePage',
    meta: { title: '首页',key:'Manager' },
    children: [
      {
        path: '/approvePage',
        redirect: '/approveSetting',
        component: () => import('@/layouts/PageView'),
        meta:{key:'SYSTEM_SETTING'},
        children: [
          {
            path: '/sys/approve/approveSetting',
            name: 'approveSetting',
            component: () => import('@/views/sys/approve/module/form'),
            meta: {key:'Approve', title: 'router.systemSetting.approve', hiddenHeaderContent: true, icon: 'read' }
          }
        ]
      },
    ]
  },
  {
    path: '/personalPerformanceDetail',
    name: 'index',
    component: BasicLayout,
    redirect:'/manager/personalPerformanceDetail',
    meta: { title: '个人业绩',key:'Manager' },
    children: [
      {
        path: '/personalPerformanceDetail',
        redirect: '/manager/personalPerformanceDetail',
        component: () => import('@/layouts/PageView'),
        meta:{key:'business'},
        children: [
          {
            path: '/manager/personalPerformanceDetail',
            name: 'personalPerformanceDetail',
            component: () => import('@/views/manager/statistics/personalPerformanceModel/personalPerformanceDetail'),
            meta: {key:'personalPerformanceDetail', title: '个人业绩详情', hiddenHeaderContent: true, icon: 'read' }
          }
        ]
      },
    ]
  },


  {
    path: '/companyBusinessDetails',
    name: 'index',
    component: BasicLayout,
    redirect:'/manager/companyBusinessDetails',
    meta: { title: '公司业绩明细',key:'Manager' },
    children: [
      {
        path: '/companyBusinessDetails',
        redirect: '/manager/companyBusinessDetails',
        component: () => import('@/layouts/PageView'),
        meta:{key:'business'},
        children: [
          {
            path: '/manager/companyBusinessDetails',
            name: 'companyBusinessDetails',
            component: () => import('@/views/manager/statistics/companyPerformance/businessDetails/index'),
            meta: {key:'companyBusinessDetails', title: '业务明细', hiddenHeaderContent: true, icon: 'read' }
          }
        ]
      },
    ]
  },



  {
    path: '/website',
    name: 'index',
    component: BasicLayout,
    redirect:'/website',
    meta: { title: '首页',key:'MINI' },
    children: [
      {
        path: '/websiteList',
        redirect: '/websiteList',
        component: () => import('@/layouts/PageView'),
        meta:{key:'websiteList'},
        children: [
          {
            path: '/website/news/add',
            name: 'expenseAdd',
            component: () => import('@/views/website/news/module/add'),
            meta: {key:'website_add',title: 'router.website.news.add', hiddenHeaderContent: true, icon: 'read' }
          },
          {
            path: '/website/news/edit',
            name: 'expenseAdd',
            component: () => import('@/views/website/news/module/edit'),
            meta: {key:'website_edit',title: 'router.website.news.edit', hiddenHeaderContent: true, icon: 'read' }
          },
          {
            path: '/website/news/preview',
            name: 'expenseAdd',
            component: () => import('@/views/website/news/module/add'),
            meta: {key:'website_news_preview',title: 'router.website.news.preview', hiddenHeaderContent: true, icon: 'read' }
          }
        ]
      },
    ]
  },
  {
    path: '/user',
    component: UserLayout,
    redirect: '/user/login',
    hidden: true,
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/Login'),
        meta: { title: 'router.login', hiddenHeaderContent: true, icon: 'read' }
      }
    ]
  },
  {
    path: '/induction',
    component: OutPage,
    redirect: '/induction',
    hidden: true,
    children: [
      {
        path: '',
        name: 'inductionOut',
        component: () => import(/* webpackChunkName: "user" */ '@/views/sys/induction/outInputInvitation'),
        meta: { title: 'router.systemSetting.induction', hiddenHeaderContent: true, icon: 'read' }
      }
    ]
  },

  {
    path: '/leaseCountAdd',
    component: Block,
    redirect: '/leaseCount/add',
    hidden: true,
    meta:{key:'Tools'},
    children: [
      {
        path: '/leaseCount/add',
        name: 'leaseCountAdd',
        component: () => import(/* webpackChunkName: "user" */ '@/views/tools/leaseCount/modules/addCountPage'),
        meta: { key:'leaseCount',title: 'router.manager.tools.leaseCount', hiddenHeaderContent: true, icon: 'read' }
      }
    ]
  },

  {
    path: '/404',
    component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/404'),
    meta: { title: 'router.404', hiddenHeaderContent: true, icon: 'read' }
  },
]

function removeDuplicateRouteNames(routes, usedNames = new Set()) {
  routes.forEach(route => {
    if (route.name) {
      if (usedNames.has(route.name)) {
        delete route.name
      } else {
        usedNames.add(route.name)
      }
    }
    if (route.children && route.children.length) {
      removeDuplicateRouteNames(route.children, usedNames)
    }
  })
}

removeDuplicateRouteNames(constantRouterMap)
